// This file autogenerated by generate-asset-types.js
// Do not modify it by hand. Any changes will be overwritten.
const sounds = {
  goalieDown: require("url:./audio/goalie-down.flac"),
  goal: require("url:./audio/goal.flac"),
  goalHorn: require("url:./audio/goal-horn.flac"),
  gateHit: require("url:./audio/gate-hit.flac"),
  gameStart: require("url:./audio/game-start.flac"),
  gameOver: require("url:./audio/game-over.flac"),
  flipperUp: require("url:./audio/flipper-up.flac"),
  flipperUp8: require("url:./audio/flipper-up-8.flac"),
  flipperUp7: require("url:./audio/flipper-up-7.flac"),
  flipperUp6: require("url:./audio/flipper-up-6.flac"),
  flipperUp5: require("url:./audio/flipper-up-5.flac"),
  flipperUp4: require("url:./audio/flipper-up-4.flac"),
  flipperUp3: require("url:./audio/flipper-up-3.flac"),
  flipperUp2: require("url:./audio/flipper-up-2.flac"),
  flipperHit: require("url:./audio/flipper-hit.flac"),
  flipperDown: require("url:./audio/flipper-down.flac"),
  flipperDown3: require("url:./audio/flipper-down-3.flac"),
  flipperDown2: require("url:./audio/flipper-down-2.flac"),
  drain: require("url:./audio/drain.flac"),
  defenderUp2: require("url:./audio/defender-up-2.flac"),
  defenderUp1: require("url:./audio/defender-up-1.flac"),
  defenderDown3: require("url:./audio/defender-down-3.flac"),
  defenderDown2: require("url:./audio/defender-down-2.flac"),
  defenderDown1: require("url:./audio/defender-down-1.flac"),
  buzz: require("url:./audio/buzz.flac"),
  buttonUp1: require("url:./audio/button-up-1.flac"),
  buttonDown1: require("url:./audio/button-down-1.flac"),
  bumper2: require("url:./audio/bumper-2.flac"),
  bumper1: require("url:./audio/bumper-1.flac"),
  boing2: require("url:./audio/boing-2.flac"),
  boing1: require("url:./audio/boing-1.flac"),
  ballRolling: require("url:./audio/ball-rolling.flac"),
  ballRollingRawSm57: require("url:./audio/ball-rolling-raw-sm57.flac"),
  ballRollingRawAt3035: require("url:./audio/ball-rolling-raw-at3035.flac"),
  ballRolling3: require("url:./audio/ball-rolling-3.flac"),
  ballRolling2: require("url:./audio/ball-rolling-2.flac"),
  ballOnBallRaw: require("url:./audio/ball-on-ball-raw.flac"),
  ballOnBall2: require("url:./audio/ball-on-ball-2.flac"),
  ballOnBall1: require("url:./audio/ball-on-ball-1.flac"),
  ballDrop1: require("url:./audio/ball-drop-1.flac")
};
export type SoundName = keyof typeof sounds;

const images = {
  wallAo1: require("./images/wall-ao-1.png"),
  wall1: require("./images/wall-1.png"),
  favicon: require("./images/favicon.png")
};
export type ImageName = keyof typeof images;

const fonts = {

};
export type FontName = keyof typeof fonts;

const levels = {

};
export type LevelName = keyof typeof levels;

const entityDefs = {

}
export type EntityDefName = keyof typeof entityDefs;

const jsonBlobs = {

};

export const RESOURCES = { sounds, images, fonts, levels, entityDefs, jsonBlobs };
